import { render, staticRenderFns } from "./LeadListTable.vue?vue&type=template&id=2a6f7608&scoped=true&lang=html"
import script from "./LeadListTable.vue?vue&type=script&lang=js"
export * from "./LeadListTable.vue?vue&type=script&lang=js"
import style0 from "./LeadListTable.vue?vue&type=style&index=0&id=2a6f7608&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6f7608",
  null
  
)

export default component.exports